export default __webpack_public_path__ + "static/media/rmvideo-after.aebfb862.png";